(function () {
  function manualSmoothScroll(targetPosition, duration) {
    var start = window.pageYOffset;
    var distance = targetPosition - start;
    var startTime = null;

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function animation(currentTime) {
      if (!startTime) startTime = currentTime;
      var elapsed = currentTime - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var ease = easeInOutQuad(progress);

      window.scrollTo(0, start + distance * ease);

      if (elapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  function closeMenuDrawer() {
    var drawerContainer = document.getElementById('Details-menu-drawer-container');
    if (!drawerContainer || !drawerContainer.hasAttribute('open')) return;

    // Click the summary to trigger Dawn's native close logic
    var summary = drawerContainer.querySelector(':scope > summary');
    if (summary) {
      summary.click();
    }
  }

  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href*="#"]');
    if (!anchor) return;

    var href = anchor.getAttribute('href');
    if (!href) return;

    // Extract the hash — works for both "#id" and "https://domain.com/#id"
    var hash = href.includes('#') ? href.split('#')[1] : null;
    if (!hash) return;

    var target = document.getElementById(hash);
    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    var isDrawerOpen = document.getElementById('Details-menu-drawer-container')
      && document.getElementById('Details-menu-drawer-container').hasAttribute('open');

    if (isDrawerOpen) {
      closeMenuDrawer();

      // Wait for drawer close animation before scrolling
      setTimeout(function () {
        var headerHeight = document.querySelector('sticky-header')
          ? document.querySelector('sticky-header').offsetHeight
          : 0;

        var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        manualSmoothScroll(targetPosition, 800);
      }, 400);
    } else {
      var headerHeight = document.querySelector('sticky-header')
        ? document.querySelector('sticky-header').offsetHeight
        : 0;

      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      manualSmoothScroll(targetPosition, 800);
    }
  }, true);
})();

(function () {
  function addReviewsIntro() {
    var header = document.querySelector(
      '#shopify-section-template--29855643664725__17783409293a195976 .jdgm-header'
    );

    if (!header) return;

    var title = header.querySelector('.jdgm-title');
    if (!title) return;

    // Prevent duplicate injection
    if (header.querySelector('.jdgm-custom-intro')) return;

    var p = document.createElement('p');
    p.classList.add('jdgm-custom-intro', 'caption', 'cstrong');
    p.textContent = 'CUSTOMER REVIEWS';

    title.insertAdjacentElement('beforebegin', p);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Judge.me loads asynchronously so we wait for it
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      addReviewsIntro();

      // Stop trying after 5 seconds
      if (document.querySelector('.jdgm-title') || attempts >= 25) {
        clearInterval(interval);
      }
    }, 200);
  });
})();

(function () {
  function addReviewsButton() {
    var arrowsBottom = document.querySelector(
      '#shopify-section-template--29855643664725__17783409293a195976 .jdgm-arrows--bottom'
    );
    if (!arrowsBottom) return;

    // Prevent duplicate injection
    if (arrowsBottom.nextElementSibling && arrowsBottom.nextElementSibling.classList.contains('jdgm-custom-cta')) return;

    var button = document.createElement('a');
    button.classList.add('button', 'jdgm-custom-cta', 'button--secondary');
    button.href = '/pages/reviews';
    button.textContent = 'Read more reviews';

    arrowsBottom.insertAdjacentElement('afterend', button);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      addReviewsButton();

      if (document.querySelector('.jdgm-arrows--bottom') || attempts >= 25) {
        clearInterval(interval);
      }
    }, 200);
  });
})();

(function () {
  function addParentNavLinks() {
    var summaries = document.querySelectorAll(
      '.section-custom-header .header__inline-menu details[data-parent-url] > summary.header__menu-item'
    );
    if (!summaries.length) return;

    summaries.forEach(function (summary) {
      if (summary.dataset.parentNavBound) return;
      summary.dataset.parentNavBound = 'true';

      summary.addEventListener('click', function (e) {
        var details = summary.closest('details');
        var url = details && details.dataset.parentUrl;
        if (!url || url === '#') return;

        var caret = summary.querySelector('.icon-caret');
        if (!caret) return;

        var caretRect = caret.getBoundingClientRect();
        var clickedOnCaret = (
          e.clientX >= caretRect.left - 8 &&
          e.clientX <= caretRect.right + 8 &&
          e.clientY >= caretRect.top - 8 &&
          e.clientY <= caretRect.bottom + 8
        );

        // If clicking the caret, always just toggle the dropdown
        if (clickedOnCaret) return;

        // If dropdown is already open and clicking the text, navigate
        if (details.open) {
          e.preventDefault();
          window.location.href = url;
        }
        // If dropdown is closed, let the click open it (default behaviour)
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      addParentNavLinks();
      if (
        document.querySelector('.section-custom-header .header__inline-menu details[data-parent-url]') ||
        attempts >= 25
      ) {
        clearInterval(interval);
      }
    }, 200);
  });
})();